import {applyMiddleware, combineReducers, createStore, StoreEnhancer} from "redux";
import {composeWithDevTools} from '@redux-devtools/extension';
import thunk from 'redux-thunk';
import {releaseStage} from "../config";
import applicationReducer from './applicationReducer';
import articleReducer from "./articleReducer";
import topicReducer from "./topicReducer";

const rootReducer = combineReducers({
  application: applicationReducer,
  entities: combineReducers({
    articles: articleReducer,
    topics: topicReducer,
  })
});

const middleware = [
  thunk,
];

let enhancers: StoreEnhancer = applyMiddleware(...middleware);
if (releaseStage === 'development') {
  enhancers = composeWithDevTools(applyMiddleware(...middleware));
}

const store = createStore(rootReducer, enhancers);

export type RootState = ReturnType<typeof rootReducer>

export default store;
